/**
 * @param value - CSS transition duration value (ie: ".25s" or "250ms")
 * @return value in milliseconds (ie: 250)
 */
export function parseCSSTransitionDuration(value: string): number {
  if (value.endsWith('ms')) {
    return parseInt(value);
  }

  if (value.endsWith('s')) {
    return parseFloat(value) * 1000;
  }

  throw new Error(`unable to parse "${value}" as CSS transition duration`);
}
